import { addDays, isAfter, isToday, parse } from 'date-fns';

import { getTodayDate } from '../DateTimeUtils';

export const checkWhetherTheDateIsTodaysDate = (date: Date): boolean =>
  isToday(date);

export const isPresentTimeExceedsMaxVisibilityTime = (
  maxVisibilityTime: string
): boolean => {
  const todayDate = getTodayDate();
  const time = parse(maxVisibilityTime, 'HH:mm', todayDate);
  const isPresentTimeExceeds = isAfter(todayDate, time);
  return isPresentTimeExceeds;
};

export const getTimeLapsedValues = (listProps: {
  timeLapsedOptions;
  selectedDate: Date;
}) => {
  const { timeLapsedOptions, selectedDate } = listProps;
  const isTodaysDate = checkWhetherTheDateIsTodaysDate(selectedDate);

  return isTodaysDate
    ? timeLapsedOptions.filter((option) => {
        const { max_visibility_time: maxVisibilityTime } = option;
        return !isPresentTimeExceedsMaxVisibilityTime(maxVisibilityTime);
      })
    : timeLapsedOptions;
};

const checkDateWithinVisibility = (maxVisibilityDate): boolean => {
  if (isPresentTimeExceedsMaxVisibilityTime(maxVisibilityDate)) {
    return true;
  }
  return false;
};

const checkAndGetMinDate = (
  dateString: string,
  maxVisibilityTime: string | undefined
) => {
  if (
    maxVisibilityTime &&
    isPresentTimeExceedsMaxVisibilityTime(maxVisibilityTime)
  ) {
    const date = eval(dateString);
    return addDays(date, 1);
  }
  return eval(dateString);
};

export const getMinAndMaxDatesBasedOnVisibility = (
  minDate,
  maxDate,
  maxVisibilityTime
) => {
  if (checkDateWithinVisibility(maxVisibilityTime) && minDate && maxDate) {
    const startDate = addDays(eval(minDate), 1);
    const endDate = addDays(eval(maxDate), 1);
    return {
      minimumDate: startDate,
      maximumDate: endDate
    };
  }
  return {
    minimumDate: minDate ? checkAndGetMinDate(minDate, maxVisibilityTime) : '',
    maximumDate: maxDate ? eval(maxDate) : ''
  };
};
